module.exports = __webpack_public_path__ + "img/yamakwa.a53dfe42.png";